import type { ComponentProps } from "react";
import Image from "next/image";
import ReactDOMServer from "react-dom/server";
import { RnBrokenFile } from "@remi/icons/next";

import { toBase64 } from "../../utils/image-placeholder";

type RemiImageNotFoundProps = Omit<ComponentProps<typeof Image>, "src">;

const renderComponentToBase64 = (Component: React.FC): `data:image/${string}` => {
  const componentString = ReactDOMServer.renderToString(<Component />);
  return toBase64(componentString);
};

const getRemiImageNotFoundSrc = (): `data:image/${string}` => {
  return renderComponentToBase64(RnBrokenFile);
};

export const RemiImageNotFound = (props: RemiImageNotFoundProps) => {
  return <Image {...props} src={getRemiImageNotFoundSrc()} />;
};
